import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllModules } from "../../modules/taxiModules";

export const fetchTaxiModules = createAsyncThunk(
  "taxiModules/fetchTaxiModules",
  async (arg, thunkAPI) => {
    try {
      const response = await getAllModules();
      return response;
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
